module.exports = __webpack_public_path__ + "media/img/frontend_application/landing-faq-1c449867e1c04084d4805a846118ce73.webp";